<template>
  <div class="account-settings-wrapper">
    <h2 class="title">Carrier Perks</h2>

    <div class="content-wrapper">
      <carrier-perks></carrier-perks>
    </div>
  </div>
</template>

<script>
import CarrierPerks from '@/components/Profile-and-settings/Perks'

export default {
  name: 'CarrierPerksPage',

  components: {
    CarrierPerks
  },

  computed: {},

  data() {
    return {
      isLoading: false
    }
  }
}
</script>

<style scoped lang="scss">
.account-settings-wrapper {
  min-height: 85vh;
  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../assets/backgrounds/hannes-egler-360942-unsplash.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}

.content-wrapper {
  background: rgba(255, 255, 255, 0.7);
  padding: 15px;
}

.middle-column {
  border-right: 1px solid blue;
  border-left: 1px solid blue;
}
</style>
